import { render, staticRenderFns } from "./accountTable.vue?vue&type=template&id=1273d29b&scoped=true"
import script from "./accountTable.vue?vue&type=script&lang=js"
export * from "./accountTable.vue?vue&type=script&lang=js"
import style0 from "./accountTable.vue?vue&type=style&index=0&id=1273d29b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1273d29b",
  null
  
)

export default component.exports